import { render, staticRenderFns } from "./feedback_list.vue?vue&type=template&id=7c55cc60&scoped=true&"
import script from "./feedback_list.vue?vue&type=script&lang=js&"
export * from "./feedback_list.vue?vue&type=script&lang=js&"
import style0 from "./feedback_list.vue?vue&type=style&index=0&id=7c55cc60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c55cc60",
  null
  
)

export default component.exports